import { render, staticRenderFns } from "./StockIncotermFields.vue?vue&type=template&id=0ba2b568&scoped=true"
import script from "./StockIncotermFields.vue?vue&type=script&lang=js"
export * from "./StockIncotermFields.vue?vue&type=script&lang=js"
import style0 from "./StockIncotermFields.vue?vue&type=style&index=0&id=0ba2b568&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba2b568",
  null
  
)

export default component.exports